import {
  ErrorFormat
} from "./chunk-FYIVMC23.mjs";
import {
  Alert
} from "./chunk-3EL7QRGL.mjs";
import {
  ErrorFilled_default
} from "./chunk-EOMCCNMZ.mjs";

// src/components/error-notification/error-notification.tsx
import React from "react";
var ErrorNotification = ({
  error,
  ...props
}) => {
  if (!error) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { ...props, variant: "critical-subtle", icon: /* @__PURE__ */ React.createElement(ErrorFilled_default, null) }, /* @__PURE__ */ React.createElement(ErrorFormat, { error }));
};

export {
  ErrorNotification
};
